// extracted by mini-css-extract-plugin
export var cartContainer = "_nr-4";
export var gray = "_nr-1";
export var itemContainer = "_nr-2";
export var itemDetails = "_nr-3";
export var strong = "_nr-0";